export const modalMixin = {
    data() {
        return {
            scrolly: null
        }
    },
    mounted() {
        const $body = document.querySelector('body')

        if ($body.classList.contains('walkthrough') || $body.scrollHeight <= window.innerHeight) {
            return
        }

        this.scrolly = window.scrollY
        $body.style.overflow = 'hidden'
        $body.style.position = 'fixed'
        $body.style.top = `-${this.scrolly - 0}px`
        $body.style.width = '100%'
        $body.classList.add('modal-opened')

        const html = document.querySelector('html')
        html.style.overflowY = 'scroll'
    },
    beforeDestroy() {
        const $body = document.querySelector('body')
        const html = document.querySelector('html')
        $body.style.removeProperty('overflow')
        $body.style.removeProperty('position')
        $body.style.removeProperty('top')
        $body.style.removeProperty('width')
        html.style.scrollBehavior = 'auto'
        $body.classList.remove('modal-opened')
        window.scrollTo(0, this.scrolly)
        html.style.removeProperty('scroll-behavior')
    }
}
